module.exports = __webpack_public_path__ + "static/media/loc2_img12.1736ee67.jpg";